/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecentItem } from './RecentItem';
import {
    RecentItemFromJSON,
    RecentItemFromJSONTyped,
    RecentItemToJSON,
} from './RecentItem';

/**
 * Provides information about recently accessed items/entities. [show only]
 * @export
 * @interface RecentItems
 */
export interface RecentItems {
    /**
     * 
     * @type {Array<RecentItem>}
     * @memberof RecentItems
     */
    items: Array<RecentItem>;
}

/**
 * Check if a given object implements the RecentItems interface.
 */
export function instanceOfRecentItems(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function RecentItemsFromJSON(json: any): RecentItems {
    return RecentItemsFromJSONTyped(json, false);
}

export function RecentItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RecentItemFromJSON)),
    };
}

export function RecentItemsToJSON(value?: RecentItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(RecentItemToJSON)),
    };
}

